module.exports = __webpack_public_path__ + "4107a73a1feb867ae74d94564eb6a400.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/180.png
// module id = 1765
// module chunks = 2